<template lang="pug">
.card
  .card-body
    show-row(:area='area')
    .divider.text-center(data-content='Plantas')
    .columns(v-if='area.plantas && area.plantas.length')
      .column.col-6.col-xs-12.py-2(v-for='planta in area.plantas' :key='planta.id')
        planta(:planta='planta' editavel)
          div(slot='footer')
            a.btn.btn-link.text-error.tooltip(@click='removerPlanta(planta)' data-tooltip='Remover planta')
              btn-content(icon='fa fa-trash-o')
    .empty(v-else)
      .empty-icon
        i.fa.fa-search.fa-4x
      .empty-title.h5 Nenhuma planta
  .card-footer
    .columns
      .column.col-auto
        slot(name='btn-remove')
      .column
      .column.col-auto
        upload-planta(:plantas='area.plantas' @selected='onSelectedPlantas' :id="area.id")
      .column.col-auto
        cadastro-plantas-picker(:cadastro='cadastro' @selected="onSelectedPlantas" :plantas-selecionadas='area.plantas')    
      .column.col-auto
        slot(name='edit')
</template>

<script>
import ShowRow from "./ShowRow"
import CadastroPlantasPicker from "./components/CadastroPlantasPicker"
import UploadPlanta from "./components/UploadPlanta"
import Planta from "./components/Planta"

export default {
  props: {
    area: { type: Object, required: true },
    cadastro: { type: Object, required: true },
  },
  components: { ShowRow, Planta, CadastroPlantasPicker, UploadPlanta },
  methods: {
    onSelectedPlantas(plantas) {
      if (!plantas || plantas.length < 1) return
      plantas.map(planta => {
        if (this.area.plantas.find(p => planta.id === p.id)) return
        this.$set(this.area.plantas, this.area.plantas.length, planta)
      })
    },
    removerPlanta(planta) {
      const options = {
        title: "Tem certeza",
        cancelLabel: "Não",
        okLabel: "Sim",
      }
      this.$dialogs.confirm("Quer remover a planta?", options).then(res => {
        if (!res.ok) return
        const plantas = this.area.plantas.filter(p => p.id !== planta.id)
        this.$set(this.area, "plantas", plantas)
      })
    },
  },
}
</script>
